export interface FileSystemEntry {
  id: string;
  name: string;
  path: string;
  type: 'file' | 'folder';
  children?: FileSystemEntry[];
  isOpen?: boolean;
}

export type InputFiles = Record<string, { code: string } | string>;

export const buildFileTree = (files: InputFiles): FileSystemEntry[] => {
  const root: FileSystemEntry = { id: 'root', name: 'root', path: '', type: 'folder', children: [] };

  for (const fullPath in files) {
    if (Object.prototype.hasOwnProperty.call(files, fullPath)) {
      const parts = fullPath.replace(/^\/+/, '').split('/'); // Remove leading slashes
      let currentLevel = root.children!;
      let currentPath = '';

      parts.forEach((part, index) => {
        currentPath = currentPath ? `${currentPath}/${part}` : part;
        const isFile = index === parts.length - 1;
        let entry = currentLevel.find(e => e.name === part && (isFile ? e.type === 'file' : e.type === 'folder'));

        if (!entry) {
          if (isFile) {
            entry = { id: fullPath, name: part, path: fullPath, type: 'file' };
            currentLevel.push(entry);
          } else {
            entry = { id: currentPath + '/', name: part, path: currentPath + '/', type: 'folder', children: [], isOpen: false };
            currentLevel.push(entry);
          }
        }
        if (!isFile && entry.type === 'folder') {
          currentLevel = entry.children!;
        }
      });
    }
  }
  // Sort entries: folders first, then alphabetically
  const sortEntries = (entries: FileSystemEntry[]) => {
    entries.sort((a, b) => {
      if (a.type === 'folder' && b.type === 'file') return -1;
      if (a.type === 'file' && b.type === 'folder') return 1;
      return a.name.localeCompare(b.name);
    });
    entries.forEach(entry => {
      if (entry.type === 'folder' && entry.children) {
        sortEntries(entry.children);
      }
    });
  };

  sortEntries(root.children!);
  return root.children!;
};

export const extractFileContents = (files: InputFiles): Record<string, string> => {
  const contents: Record<string, string> = {};
  for (const path in files) {
    if (Object.prototype.hasOwnProperty.call(files, path)) {
      const fileData = files[path];
      contents[path] = typeof fileData === 'string' ? fileData : fileData.code;
    }
  }
  return contents;
};
